<template>
  <div>
    <v-row>
      <v-col class="text-subtitle-2 gray--text text--lighten-1">
        Acompanhante
      </v-col>
    </v-row>

    <v-row>
      <v-col>
        <v-text-field
          :value="companionName"
          @input="triggerUpdateAndSaveFor('companionName', $event)"
          placeholder=" "
          label="Nome do acompanhante"
          dense
          outlined
          :disabled="disableEdit"
          background-color="white"
        />
      </v-col>
    </v-row>

    <v-row>
      <v-col>
        <v-combobox
          :value="companionRelationship"
          @input="triggerUpdateAndSaveFor('companionRelationship', $event)"
          placeholder=" "
          label="Parentesco"
          dense
          outlined
          hide-details
          :disabled="disableEdit"
          :items="companionRelationships"
          item-text="name"
          background-color="white"
        />
      </v-col>
    </v-row>

    <v-row>
      <v-col class="text-subtitle-2 gray--text text--lighten-1">
        Período de afastamento
      </v-col>
    </v-row>

    <v-row>
      <v-col>
        <v-text-field
          :value="medicalLeaveStart"
          @input="triggerUpdateAndSaveFor('medicalLeaveStart', $event)"
          placeholder=" "
          label="Inicio"
          type="date"
          dense
          outlined
          clearable
          background-color="white"
          :hide-details="!errors.medicalLeaveStart"
          :error-messages="errors.medicalLeaveStart"
          :disabled="disableEdit"
        />
      </v-col>
    </v-row>

    <v-row>
      <v-col>
        <v-text-field
          :value="medicalLeaveEnd"
          @input="triggerUpdateAndSaveFor('medicalLeaveEnd', $event)"
          placeholder=" "
          label="Fim"
          type="date"
          dense
          outlined
          clearable
          background-color="white"
          :hide-details="!errors.medicalLeaveEnd"
          :error-messages="errors.medicalLeaveEnd"
          :disabled="disableEdit"
        />
      </v-col>
    </v-row>

    <v-row>
      <v-col>
        <v-combobox
          :value="serviceType"
          @input="triggerUpdateAndSaveFor('serviceType', $event)"
          placeholder=" "
          label="Tipo de serviço"
          dense
          outlined
          hide-details
          :items="serviceTypes"
          item-text="name"
          background-color="white"
          :disabled="disableEdit"
        />
      </v-col>
    </v-row>

    <v-row>
      <v-col>
        <v-textarea
          :value="notes"
          @input="triggerUpdateAndSaveFor('notes', $event)"
          label="Notas"
          outlined
          hide-details
          background-color="white"
          :disabled="disableEdit"
        />
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  name: "MedicalCertificateFormAcompanhanteFields",
  props: {
    companionName: {
      type: String,
      required: true,
    },
    companionRelationship: {
      type: Object,
      required: false,
    },
    medicalLeaveStart: {
      type: String,
      required: false,
    },
    medicalLeaveEnd: {
      type: String,
      required: false,
    },
    serviceType: {
      type: [String, Object],
      required: false,
    },
    notes: {
      type: String,
      required: false,
    },
    disableEdit: {
      type: Boolean,
      required: true,
    },
    companionRelationships: {
      type: Array,
      required: true,
    },
    serviceTypes: {
      type: Array,
      required: true,
    },
    errors: {
      type: Object,
      required: true,
    },
  },
  methods: {
    triggerUpdateAndSaveFor(syncedProp, value) {
      this.$emit(`update:${syncedProp}`, value);
      this.$emit("save");
    },
  },
};
</script>

<style scoped></style>
